/**
 * the state which holds the current media info (for responsive behaviour)
 */
export default {
    namespaced: true,

    state: {
        data: {},
    },

    getters: {
        media: state => state.data || {},
    },

    actions: {
        update ({commit}, newState ) {
            commit('update', newState);
        },
    },

    mutations: {
        update (state, newState) {
            state.data = newState;
        }
    },
};
